module.exports = __webpack_public_path__ + "static/media/step3-backg.6649b58c.png";